<!--从首页跳转到该页面 校友信息已补全 校友id code=400
同时login页面 code=105 已补全个人信息 window.localStorage.getItem('isCompletionData') == 1 -->
<template>
  <div>
    <div>
      <img v-if="realNam === true" class="failImg" src="./images/btn_chenggong_nor@2x.png" alt="" srcset="">
      <img v-else-if="realNam === false" class="failImg" src="./images/btn_shibai_nor@2x.png" alt="" srcset="">
      <div v-if="realNam === true" class="com-text short-text">已补全个人信息</div>
      <div v-else-if="realNam === false" class="com-text short-text">未进行实名认证</div>
      <!-- <div v-if="alumnus_id" class="com-text short-text" style="color: red;">校友ID：{{ alumnus_id }}</div>
      <div class="com-text long-text"><span v-if="alumnus_id">请记住您的校友ID，后续实名认证需要使用校友ID
          进行认证。</span></div> -->
    </div>
    <!-- <el-button style="display: block;" class="lwork" type="primary" @click="contact">前往实名认证</el-button> -->

    <!-- 不去实名认证，直接去主页 -->
    <el-button style="display: block;" class="lwork" type="primary" @click="contact">返回主页面</el-button>

    <!--  <el-button style="display: block;" class="hwork" type="text" @click="revocate">退出认证</el-button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: localStorage.getItem('user_id'),
      baseURL: "",
      realNam: true,
      alumnus_id: 'ppp',
    }
  },
  methods: {
    async getAlumniId() {
      if (this.userId) {
        const res = await this.$http.get(`/xjcard/selectXJCard?user_id=${this.userId}`)
        if (res.data && res.data.alumnus_id) {
          this.alumnus_id = res.data.alumnus_id
          // 用户已经补全个人信息,用于后续再次登录跳转
          window.localStorage.setItem("isCompletionData", 1)
        }
      } else {
        this.$toast('用户信息错误,请重新登录')
        localStorage.removeItem('openid')
        await this.$router.push('/login')
      }
    },
    async contact() {
      // 使用对话框（confirm）向用户显示提示信息
      // this.$dialog.confirm({
      //   title: '提示',
      //   message: '请记住校友ID：' + this.alumnus_id,
      // }).then(() => {
        // 用户点击了对话框中的确定按钮
        // 构建回调URL并将其编码
        // const callbackUrl = encodeURIComponent(`https://gcxy.alumni-resource.com/xyh/index?userId=${localStorage.getItem("user_id")}&status=1`)

        //注册成功直接跳转到 校友服务 页面
        this.$router.push('/Index')
        // const callbackUrl = encodeURIComponent(`https://gcxy.alumni-resource.com/mine`)

        // const callbackUrl = `${location.origin}/#/index?userId=${localStorage.getItem("user_id")}&status=1`
        // this.$toast('跳过实名 直接跳转回调地址')
        // console.log('跳过实名 直接跳转回调地址')
        // location.href = callbackUrl // 测试使用
         // 在正式环境中，使用构建好的回调URL进行跳转
      //   location.href = `https://self-id.dlmu.edu.cn/public/client/account-activate/name?backUrl=${callbackUrl}` // 正式环境使用
      // }).catch(() => {
        // on cancel
         // 用户点击了对话框中的取消按钮
        // 在这里可以处理取消操作，可以不进行任何操作
    //   });
     },
    /* revocate() {
      this.$router.push("/index?realNam=false")
    }, */
  },
  created() {
    this.baseURL = location.href
    //    console.log(this.baseURL.substring(0,23));
    this.baseURL = this.baseURL.substring(0, 24)
    // console.log(this.baseURL);
    // console.log(this.$route);
    this.getAlumniId()
  },
}
</script>

<style lang="less" scoped>
.com-text {
  margin: 10px auto;
  text-align: center;
  color: #333333;
}

.short-text {
  font-size: 20px;
}

.long-text {
  width: 80%;
  margin: 50px auto;
  color: #333333;
  font-size: 16px;
}

.lwork {
  width: 80%;
  background-color: #00706E;
  height: 35px;
  font-size: 20px;
  color: #fff;
  margin: 0 auto;
  border-radius: 35px;
  padding: 0;
}

.failImg {
  border-radius: 50%;
  height: 200px;
  width: 250px;
  border-radius: 50%;
  display: block;
  margin: 25px auto;
}

.hwork {
  color: #333333;
  margin: 15px auto;
  text-align: center;
  width: 80%;
}

.el-button+.el-button {
  margin-left: 9%;
}

.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin: auto;
}

.el-button+.el-button {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/completeInfo.vue